import { type RouteComponentProps } from '@gatsbyjs/reach-router'
import { rem, SizedBox } from '@collabhouse/shared'
import React, { type FunctionComponent } from 'react'
import { Helmet } from 'react-helmet'

import OverviewPageTemplate from '../../components/overview-page-template/OverviewPageTemplate'
import Page from '../../components/page/Page'
import { useUser } from '../../hooks/useUser'
import CollaborationOverview from '../collaboration-overview/CollaborationOverview'

const MyCollabs: FunctionComponent<React.PropsWithChildren<RouteComponentProps>> = () => {
  const { redirectToLoginIfNotLoggedIn } = useUser()

  if (redirectToLoginIfNotLoggedIn()) return null

  return (
    <Page>
      <Helmet>
        <title>Collabs</title>
      </Helmet>
      <OverviewPageTemplate title="Collabs">
        <SizedBox height={{ desktop: rem(32), mobile: rem(24) }} />
        <CollaborationOverview />
      </OverviewPageTemplate>
    </Page>
  )
}

export default MyCollabs
